import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { Button, Modal } from 'react-bootstrap';
import {
  caseTypeSelectOptions,
  chapterSelectOptions,
  limitSelectOptions,
  querySelectOptions,
  regionSelectOptions,
} from '../formData';
import '../AdvancedSearch.less';
import districtNosOptions from '../../../data/districtNosOptions';
import {
  RegionField,
  QueryField,
  CaseTitlesField,
  PartyNameField,
  ChapterField,
  TypeField,
  NatureOfSuit,
} from '../fields';

const CaseFilterModal = ({ onSave, show, onClose, filter }) => (
  <Modal show={show} onHide={onClose} backdrop="static" keyboard={false} dialogClassName="advanced-search-modal">
    <div className="filings-page">
      <Form
        onSubmit={onSave}
        initialValues={filter}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Case Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="advanced-search-form">
                <div className="form-item form-item-row">
                  <div className="col-2">
                    <RegionField regionSelectOptions={regionSelectOptions} />
                  </div>
                  <div className="col-2">
                    <QueryField
                      querySelectOptions={querySelectOptions}
                      disabled={['cases', 'petitions', 'schedules'].includes(filter.tab)}
                    />
                  </div>
                </div>
                {filter.court_type === 'bankruptcy' && (
                  <div className="form-item form-item-row">
                    <div className="col-2">
                      <ChapterField chapterSelectOptions={chapterSelectOptions} />
                    </div>
                    <div className="col-2">
                      <TypeField caseTypeSelectOptions={caseTypeSelectOptions} />
                    </div>
                  </div>
                )}
                {filter.court_type === 'civil' && (
                  <div className="form-item form-item-row">
                    <div style={{ width: '100%' }}>
                      <NatureOfSuit districtNosOptions={districtNosOptions} />
                    </div>
                  </div>
                )}
                <div className="form-item form-item-row">
                  <div className="col-2">
                    <CaseTitlesField limitSelectOptions={limitSelectOptions} disabled={filter.tab === 'petitions'} />
                  </div>
                  {filter.tab === 'cases' && (
                    <div className="col-2">
                      <PartyNameField limitSelectOptions={limitSelectOptions} />
                    </div>
                  )}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={onClose}>Cancel</Button>
              <Button bsStyle="primary" type="submit">
                Apply
              </Button>
            </Modal.Footer>
          </form>
        )}
      />
    </div>
  </Modal>
);

CaseFilterModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  filter: PropTypes.object.isRequired,
};

CaseFilterModal.defaultProps = {
  show: false,
};

export default CaseFilterModal;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/CaseFilterModal.jsx